import React, {Component} from "react"
import PropTypes from "prop-types"
import {withRouter} from "react-router-dom"
import NavigationSidebar from "../components/Navigation/NavigationSidebar"
import Filter from "../components/Filter/Filter"
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs"
import ProductList from "../components/Product/ProductList"
import ProductCol from "../components/Product/ProductCard"
import ProductColDetail from "../components/Product/ProductColDetail"
{/*ELEM REACT16 CHANGE */}
import shop from "shop/shop"

@withRouter
export default class BrandPage extends Component {
  constructor(props) {
    super( props )
    this.state = {
      products: [],
      loaded:   false,
      filter:   {
        total:       24,
        pageSize:    shop.config.pageSize,
        currentPage: 1,
      },
      query:    {
        page:   props.location.page || 1,
        count:  props.location.count || shop.config.pageSize,
        total:  48,
        filter: null,
        limit:  3,
        id:     null
      }
    }
  }

  componentDidMount() {
    this.loadFrom( this.props )
  }

  componentWillReceiveProps(props) {
    if ( this.id !== props.params.id ) {
      this.loadFrom( props )
    }
  }

  loadFrom(props) {
    let id        = props.params.id || props.params.parent
    let { query } = props.location
    query.count   = query.count || this.state.query.count
    query.page    = query.page || 1
    this.load( id, query )
  }

  load(brand, query) {
    console.log( `loading query`, brand, query )
    this.id    = brand
    let filter = new shop.Filter()
    query.filter = filter
      .searchField( true )
      .field( "herst" )
      .query( this.id )

    console.log( `searching`, query )
    shop.products.search( "%%", query )
      .then( res => {
        this.setState( {
          size:     res.size,
          products: res.products,
          query,
        } )
      } )
  }

  onChangeFilter = (filter) => {
    this.updateQuery( filter )
  }

  updateQuery({ page, sort, pageSize, id }) {
    // console.log(`change`, {
    //    page,
    //    sort,
    //    pageSize,
    //    id
    // })
    id          = id || this.id
    let query   = this.props.location.query
    query.page  = page || query.page
    query.count = pageSize || query.count
    query.sort  = sort || query.sort
    query.id    = id || query.id

    this.props.history.push( {
      pathname: "/brand/" + id,
      query
    } )

    this.load( id, query )
  }

  render() {
    let ids      = [
      100002,
      100003,
      100004,
      100005,
      100008
    ]
    let products = this.state.products.map( (product, key) => {
      return <ProductColDetail key={key}
                               product={product}> </ProductColDetail>
    } )

    let filter = {
      currentPage: Number( this.state.query.page ),
      total:       Number( this.state.size ) || 6,
      pageSize:    Number( this.state.query.count ),
      id:          String( this.state.query.id ),
      sort:        String( this.state.query.sort )
    }

    let path = []

    path.push( {
      title: "Alle Marken",
      link:  `/cms/brands`
    } )
    path.push( {
      title: this.props.params.id,
      link:  `/brand/${this.props.params.id}`
    } )

    return (
      <div className="container ">
        {/*<div>*/}
        {/*<pre>{JSON.stringify(this.state.filter, null, 2) }</pre>*/}
        {/*</div>*/}
        {/*<div><pre>{JSON.stringify(this.props.params, null, 2) }</pre></div>*/}
        <Breadcrumbs path={path}/>
        <tr className="padding-top">
          <td>
            <NavigationSidebar> </NavigationSidebar>
          </td>
          <td>
            {/*Filter*/}
            <section style={{ marginBottom: "0" }}>
              <Filter onChange={this.onChangeFilter} {...filter} />
            </section>
            {/*Products from Category*/}
            <section>
              <tr>
                {products}
              </tr>
            </section>

            {/*Filter*/}
            <section>
              <Filter showFilter={true}
                      onChange={this.onChangeFilter} {...filter} />
            </section>
          </td>
        </tr>
        <tr>
          <td sm="1">
            {/*Topseller*/}
            <section>
              <ProductList
                title="Topseller"
                sm="1/5"
                list={ids}
                repeat={ProductCol}> </ProductList>
            </section>
          </td>
        </tr>
      </div>
    )
  }
}

BrandPage.propTypes = {
  params:  PropTypes.object,
  filter:  PropTypes.object,
  location:PropTypes.object
}




// WEBPACK FOOTER //
// ./src/pages/BrandPage.js